export enum ClientApplication {
  CHROME_EXTENSION = 'chrome-extension',
  IOS = 'iOS',
}

export enum LogType {
  CAMERA_PERMISSIONS = 'camera-permissions',
}

